export default "__VITE_ASSET__c23015cb__"